import $ from 'jquery';
import { spin } from './_site';
import { validatefields } from './form';
import { createAlert } from './window';
import Mustache from '../../../_lib/plugins/mustache/mustache';
require('jquerySpin');

let timeout = {},
    map,
    markers = [],
    infoWindow,
    mustache = {};

export const storeDetailsTemplate = () => {
    return '\
    <div class="store-list__item">\
        <span class="store-list__heading">{{ name }}</span>\
        <div class="store-list__content text-box">\
            <p>\
                {{ address }}\
                {{ #telephone }}<br />Phone: <a href="tel:{{ telephone }}">{{ telephone }}</a>{{ /telephone }}\
                {{ #email }}<br />Email: <a href="mailto:{{ email }}">{{ email }}</a>{{ /email }}\
            </p>\
        </div>\
    </div>';
};
export const clearLocations = () => {
    var $storesList = $('#stores-list'),
        $storesListContainer = $storesList.parent();

    $storesListContainer.hide();
    $storesList.html('');
};
export const createOption = (store, index) => {
    var latlng = store.latlng,
        id = store.id,
        name = store.name,
        address = store.address,
        phone = store.phone,
        email = store.email,
        $storesList = $('#stores-list'),
        $storesListContainer = $storesList.parent();

    function precisionRound(number, precision) {
        var factor = Math.pow(10, precision);
        return Math.round(number * factor) / factor;
    }

    store.index = index;

    // store.distance = precisionRound(Number(store.distance), 1) + ' Km';
    //
    // if(isNaN(store.distance)) {
    //     store.distance = null;
    // }

    $storesList.append(Mustache.render(storeDetailsTemplate(), store));
    $storesListContainer.show();
};
export const displayLocations = (stores, lat, lng) => {
    if (stores.length) {
        // cycle stores
        for (let i = 0; i < stores.length; i++) {
            // create option
            createOption(stores[i], i);
        }
    }
};
export const searchNearLocations = (lat, lng, $el) => {
    var $submit = $el,
        $submitAux = $submit.children('span'),
        $form = $submit.closest('.form'),
        url = $form.data('action'),
        flag = false,
        submitClass = 'form__submit',
        spinner = $.extend(true, {}, spin),
        data = {
            lat: lat,
            lng: lng,
        };

    function toggleLoader(flag) {
        if (flag) {
            // add loader
            $submit.addClass(submitClass + '--loading');
            // $submitAux.spin(spinner);
        } else {
            // remove loader
            $submit.removeClass(submitClass + '--loading');
            $submitAux.spin(false);
        }
    }

    // prevent multiple clicks
    if ($submit.hasClass('button--disabled')) {
        return false;
    }

    clearLocations();

    spinner.color = '#000000';

    console.log(data);

    // send data
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        cache: false,
        dataType: 'json',
        beforeSend: function() {
            // add loader
            toggleLoader(true);
        },
        success: function(response) {
            console.log(response);

            if (response.status) {
                displayLocations(response.stores, lat, lng);
            } else {
                // create alert
                createAlert(response, 'error');
            }

            // remove loader
            toggleLoader(false);
        },
        error: function(response) {
            // create alert
            createAlert(response, 'error');
            // remove loader
            toggleLoader(false);
        },
    });
};
export const searchLocations = ($el) => {
    let $form = $el.closest('.form'),
        $address = $form.find('input[name=address]'),
        // address = $address.data('address') || $address.val(),
        address = $address.val(),
        geocoder = new google.maps.Geocoder(),
        spinner = $.extend(true, {}, spin),
        $submit = $el,
        $submitAux = $submit.children('span');

    spinner.color = '#000000';

    console.log(address);

    // validation errors
    if (!validatefields($form, true)) {
        return false;
    }

    $submit.addClass('form__submit--loading');
    $submitAux.spin(spinner);

    geocoder.geocode(
        {
            address: address,
            componentRestrictions: {
                country: 'au',
            },
        },
        function(results, status) {
            var location = results[0].geometry.location;

            if (status == google.maps.GeocoderStatus.OK) {
                console.log(results[0].geometry);
                searchNearLocations(location.lat(), location.lng(), $el);
            } else {
                createAlert(
                    {
                        message: '"' + address + '" not found.',
                    },
                    'error'
                );
            }
        }
    );
};
export const binds = () => {
    // ---------------- search locations
    $('.stores').on('click.stores', '[data-search-stores]', function(event) {
        event.preventDefault();
        searchLocations($(this));
    });
};
